<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chifattal0008#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chifattal0009#intro">Introduction: Guerrilla Marketing</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0010#story01">Omar</a></p>
<p class="toc"><a class="xref" href="#/chifattal0011#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span> An Archaeology of Media Spectacle, 1974–2008</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0012#story02">Juana</a></p>
<p class="toc"><a class="xref" href="#/chifattal0013#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span> Operation Christmas</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0014#story03">Gabriel</a></p>
<p class="toc"><a class="xref" href="#/chifattal0015#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span> Operation Genuine</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0016#story04">Claudia</a></p>
<p class="toc"><a class="xref" href="#/chifattal0017#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span> The Good Life Deferred and Risks of Remobilization</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0018#story05">Sergio</a></p>
<p class="toc"><a class="xref" href="#/chifattal0019#conc"><span class="sm">CONCLUSION:</span> The Colombian Model</a></p>
<p class="toc1"><a class="xref" href="#/chifattal0020#story06">Diego</a></p>
<p class="toc"><a class="xref" href="#/chifattal0021#epil"><span class="sm">EPILOGUE:</span> Target Intimacy</a></p>
<p class="tocbmf"><a class="xref" href="#/chifattal0022#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chifattal0023#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chifattal0024#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chifattal0025#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-fattal-0007.vue?8f37f2ea